import { message } from 'ant-design-vue'

/**
 * 文件类型对应图标映射表
 */
export const FILE_TYPE_ICON_MAP: Record<string, string> = {
  png: 'png',
  psd: 'psd',
  txt: 'txt',
  ppt: 'ppt',
  pptx: 'ppt',
  mp4: 'video',
  mov: 'video',
  zip: 'zip',
  '7z': 'zip',
  rar: 'zip',
  doc: 'word',
  docx: 'word',
  html: 'html',
  jpg: 'jpg',
  jpeg: 'jpg',
  mp3: 'mp3',
  wav: 'mp3',
  pdf: 'pdf',
  gif: 'gif',
  ai: 'ai',
  xlsx: 'excel',
  xls: 'excel',
  csv: 'excel'
} as const

/**
 * 图片文件类型列表
 */
export const IMAGE_FILE_TYPES: string[] = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'] as const

/**
 * 根据文件后缀名获取对应图标名称
 * @param fileExt 文件后缀名
 * @returns 图标名称
 */
export const getFileIcon = (fileExt?: string | null): string => {
  const ext = (fileExt ?? '').toLowerCase()
  return FILE_TYPE_ICON_MAP[ext] || 'upload'
}

/**
 * 判断是否为图片文件类型
 * @param fileExt 文件后缀名
 * @returns 是否为图片文件类型
 */
export const isImageFileType = (fileExt?: string | null): boolean => {
  const ext = (fileExt ?? '').toLowerCase()
  return IMAGE_FILE_TYPES.includes(ext)
}

/**
 * 下载
 * @param downloadUrl 下载链接
 */
export const handleDownload = (downloadUrl: string = ''): void => {
  if (!downloadUrl) {
    message.error('下载链接不存在')
    return
  }
  window.open(downloadUrl, '_blank')
  message.success('下载成功')
}
